import { normalizeTemplateIds } from "../../../../components/FilterMatches/templateFilters";
import {
  deriveSelectedMatches,
  filterMatchesByDateRange,
  getMatchesSummaryLabel,
  getSelectedMatchIds,
} from "../../team/helpers/pageFilters";

export { filterMatchesByDateRange, getMatchesSummaryLabel };

export const EMPTY_SELECTED_FILTERS = {
  checkedIds: [],
  params: [],
};

const SEASON_YEAR_PATTERN = /\d{4}/g;

const getSeasonYears = (season) => {
  const rawLabel =
    season?.year_season?.years ||
    season?.year_season ||
    season?.years ||
    season?.title ||
    "";

  const matchedYears = String(rawLabel).match(SEASON_YEAR_PATTERN) || [];
  return Array.from(new Set(matchedYears));
};

const isSingleYearSeason = (season) => getSeasonYears(season).length === 1;

export const buildSelectedFiltersFromStoredGroups = (groups) => {
  if (!Array.isArray(groups)) {
    return EMPTY_SELECTED_FILTERS;
  }

  const checkedParams = groups.flatMap((group) =>
    (group?.[1] || []).filter((parameter) => Boolean(parameter?.checked))
  );
  const checkedIds = normalizeTemplateIds(
    checkedParams.map((parameter) => parameter?.id)
  );

  return {
    checkedIds,
    params: checkedParams.filter((parameter) =>
      checkedIds.includes(Number(parameter?.id))
    ),
  };
};

export const derivePlayerSelectedMatchIds = ({
  matches = [],
  selectedCompetition = [],
  selectedMatchCount = null,
}) => {
  return getSelectedMatchIds(
    deriveSelectedMatches({
      matches,
      selectedCompetition,
      selectedMatchCount,
    })
  );
};

export const derivePlayerSelectedSeasonItems = (
  availableSeasons = [],
  selectedSeasonId
) => {
  if (!Array.isArray(availableSeasons) || availableSeasons.length === 0) {
    return [];
  }

  const primarySeason =
    availableSeasons.find(
      (item) => String(item?.id) === String(selectedSeasonId)
    ) || availableSeasons[0];

  if (!primarySeason) {
    return [];
  }

  if (!isSingleYearSeason(primarySeason)) {
    return [primarySeason];
  }

  const [selectedYear] = getSeasonYears(primarySeason);
  if (!selectedYear) {
    return [primarySeason];
  }

  const linkedSeasonCandidates = availableSeasons.filter((seasonItem) => {
    if (String(seasonItem?.id) === String(primarySeason?.id)) {
      return false;
    }

    const seasonYears = getSeasonYears(seasonItem);
    return seasonYears.length === 2 && seasonYears.includes(selectedYear);
  });

  const preferredLinkedSeason =
    linkedSeasonCandidates.find(
      (seasonItem) => getSeasonYears(seasonItem)[0] === selectedYear
    ) || linkedSeasonCandidates[0] || null;

  return preferredLinkedSeason
    ? [primarySeason, preferredLinkedSeason]
    : [primarySeason];
};

export const resolvePlayerPrimarySeasonId = (
  availableSeasons = [],
  seasonIds = []
) => {
  const normalizedSeasonIds = normalizeTemplateIds(seasonIds);
  if (
    !Array.isArray(availableSeasons) ||
    availableSeasons.length === 0 ||
    normalizedSeasonIds.length === 0
  ) {
    return null;
  }

  const matchedSeasons = availableSeasons.filter((seasonItem) =>
    normalizedSeasonIds.includes(Number(seasonItem?.id))
  );

  if (matchedSeasons.length === 0) {
    return null;
  }

  const preferredSingleYearSeason = matchedSeasons.find((seasonItem) =>
    isSingleYearSeason(seasonItem)
  );

  return preferredSingleYearSeason?.id ?? matchedSeasons[0]?.id ?? null;
};
